"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var framer_motion_1 = require("framer-motion");
var useDropdown_1 = require("./useDropdown");
var styles_1 = require("../../styles");
var DropdownWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  .triggerButton {\n    ", "\n    color: ", ";\n\n    span {\n      color: ", ";\n      position: relative;\n      margin-left: ", ";\n\n      &::after {\n        content: url('/images/svg/arrow-down.svg');\n        display: inline-block;\n        transition: transform 300ms ", ";\n        margin-left: ", ";\n      }\n\n      &[data-expanded='true']::after {\n        transform: rotate(-180deg);\n      }\n    }\n  }\n\n  ", "\n"], ["\n\n  .triggerButton {\n    ", "\n    color: ", ";\n\n    span {\n      color: ", ";\n      position: relative;\n      margin-left: ", ";\n\n      &::after {\n        content: url('/images/svg/arrow-down.svg');\n        display: inline-block;\n        transition: transform 300ms ", ";\n        margin-left: ", ";\n      }\n\n      &[data-expanded='true']::after {\n        transform: rotate(-180deg);\n      }\n    }\n  }\n\n  ", "\n"])), (0, styles_1.getP18_1)(), function (_a) {
    var theme = _a.theme;
    return (0, styles_1.hex2Rgba)(theme.colors.greendark, 0.5);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greendark;
}, (0, styles_1.getRelative)(10, 'mobile'), function (_a) {
    var theme = _a.theme;
    return theme.ease;
}, (0, styles_1.getRelative)(10, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .triggerButton span {\n      margin-left: ", ";\n\n      &::after { margin-left: ", "; }\n    }\n  "], ["\n    .triggerButton span {\n      margin-left: ", ";\n\n      &::after { margin-left: ", "; }\n    }\n  "])), (0, styles_1.getRelative)(10, 'desktop'), (0, styles_1.getRelative)(10, 'desktop')));
var OptionsList = (0, styled_components_1.default)(framer_motion_1.motion.ul)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 0px 2px 4px 0 rgba(0,0,0, .2);\n  right: 0;\n  top: 100%;\n  height: 0;\n  opacity: 0;\n  overflow-y: auto;\n  padding: ", " ", " ", ";\n  position: absolute;\n  width: auto;\n  z-index: 10;\n  ", "\n\n  ", "\n\n  li {\n    cursor: pointer;\n    margin-bottom: ", ";\n    opacity: .4;\n    color: ", ";\n    width: 100%;\n    background-color: ", ";\n    transition: opacity 300ms ", ", background-color 300ms ", ";\n\n    ", "\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    &:active,\n    &:hover,\n    &.active {\n      opacity: 1;\n    }\n\n    button {\n      ", "\n    }\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: 0px 2px 4px 0 rgba(0,0,0, .2);\n  right: 0;\n  top: 100%;\n  height: 0;\n  opacity: 0;\n  overflow-y: auto;\n  padding: ", " ", " ", ";\n  position: absolute;\n  width: auto;\n  z-index: 10;\n  ", "\n\n  ", "\n\n  li {\n    cursor: pointer;\n    margin-bottom: ", ";\n    opacity: .4;\n    color: ", ";\n    width: 100%;\n    background-color: ", ";\n    transition: opacity 300ms ", ", background-color 300ms ", ";\n\n    ", "\n\n    &:last-of-type {\n      margin-bottom: 0;\n    }\n\n    &:active,\n    &:hover,\n    &.active {\n      opacity: 1;\n    }\n\n    button {\n      ", "\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, (0, styles_1.getRelative)(20, 'mobile'), (0, styles_1.getRelative)(30, 'mobile'), (0, styles_1.getRelative)(30, 'mobile'), (0, styles_1.hideScrollbar)(), styles_1.mq.greaterThan('tablet')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n  "], ["\n    padding: ", " ", " ", ";\n  "])), (0, styles_1.getRelative)(20, 'desktop'), (0, styles_1.getRelative)(30, 'desktop'), (0, styles_1.getRelative)(30, 'desktop')), (0, styles_1.getRelative)(20, 'mobile'), function (_a) {
    var theme = _a.theme;
    return theme.colors.greendark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.ease;
}, function (_a) {
    var theme = _a.theme;
    return theme.ease;
}, styles_1.mq.greaterThan('tablet')(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      margin-bottom: ", ";\n    "], ["\n      margin-bottom: ", ";\n    "])), (0, styles_1.getRelative)(20, 'desktop')), (0, styles_1.getP18_1)());
var optionsListVariants = {
    collapsed: {
        height: '0',
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transition: __assign({}, (0, styles_1.getTransition)())
    },
    expanded: {
        height: 'auto',
        opacity: 1,
        display: 'block',
        transition: __assign({}, (0, styles_1.getTransition)())
    }
};
var getOptions = function (options, onClickOption, currentSelection) {
    return options.map(function (option, idx) { return ((0, jsx_runtime_1.jsx)("li", __assign({ className: option.text === currentSelection ? 'active' : '' }, { children: (0, jsx_runtime_1.jsx)("button", __assign({ onClick: function () { onClickOption(option); } }, { children: option.text })) }), idx)); });
};
var getInitialSelection = function (options) {
    var _a, _b;
    if ((_a = options[0]) === null || _a === void 0 ? void 0 : _a.currentVariantId) {
        var selected = options.filter(function (option) { return option.variant.bigcommerce_id === option.currentVariantId; })[0];
        return (_b = selected === null || selected === void 0 ? void 0 : selected.text) !== null && _b !== void 0 ? _b : options[0];
    }
    else {
        return options[0];
    }
};
exports.Dropdown = (0, react_1.memo)(function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, trigger = _a.trigger, options = _a.options;
    var _c = __read((0, useDropdown_1.useDropdown)(), 4), triggerRef = _c[0], dropdownRef = _c[1], expanded = _c[2], toggleExpanded = _c[3];
    var _d = __read((0, react_1.useState)(getInitialSelection(options)), 2), currentSelection = _d[0], setSelection = _d[1];
    var onClickOption = function (option) {
        var _a;
        toggleExpanded();
        setSelection((_a = option.text) !== null && _a !== void 0 ? _a : option);
        // Exception for variants
        option.setCurrentVariant && option.setCurrentVariant(option.variant);
    };
    var Options = (0, react_1.useMemo)(function () { return getOptions(options, onClickOption, currentSelection); }, [options]);
    return ((0, jsx_runtime_1.jsxs)(DropdownWrapper, __assign({ className: className }, { children: [(0, jsx_runtime_1.jsxs)("button", __assign({ className: 'triggerButton', ref: triggerRef, type: 'button', onClick: toggleExpanded }, { children: [trigger, (0, jsx_runtime_1.jsx)("span", __assign({ "data-expanded": expanded }, { children: currentSelection }))] })), (0, jsx_runtime_1.jsx)(OptionsList, __assign({ ref: dropdownRef, initial: 'collapsed', variants: optionsListVariants, animate: expanded ? 'expanded' : 'collapsed' }, { children: Options }))] })));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
